import React from 'react';

// Horizontal filter chips — same layout/style as Gallery filters
const CategoryFilters = ({ filters, active, onSelect }) => (
  <div className="mt-6 md:mt-8 overflow-x-auto scrollbar-hide">
    <div className="flex flex-nowrap justify-center gap-2 min-w-full w-max mx-auto">
      {filters.map((f) => {
        const isActive = active === f.val;
        return (
          <button
            key={f.val}
            type="button"
            onClick={() => onSelect(f.val)}
            className={`gallery-filter flex-shrink-0 px-4 py-1.5 md:px-5 md:py-2 rounded-lg text-base font-medium transition-colors border ${
              isActive
                ? 'bg-orange-500 text-white border-orange-500 active'
                : 'bg-white text-gray-700 border-gray-200 hover:border-orange-300'
            }`}
          >
            {f.label}
          </button>
        );
      })}
    </div>
  </div>
);

export default CategoryFilters;
